import {ID} from '../../_metronic/helpers'
import {AddressRequest, IAddresses} from './Address/address'
import {BankRequest, IBankData} from './bank'
import {Sale} from '../../pages/sales/list/core/_models'
import {IMedicalConditionResponse, TMedicalConditionPersonRequest} from './medicalCondition'

export type TPersonRequest = {
  id?: number
  type: number
  name: string
  age?: string
  preferredName?: string
  email?: string
  franchiseEmail?: string
  document: string
  birthDate?: string
  gender?: string
  rg?: string
  job?: string
  nationality?: number
  contacts?: Array<ContactRequest>
  addresses?: Array<AddressRequest>
  bankData?: Array<BankRequest>
  observations?: Array<IPersonObservation>
  medicalConditions?: Array<TMedicalConditionPersonRequest>
  reduceTime: boolean
  hideAvatar: boolean
  howMet?: number
  howMetObservation?: string
  alerts?: string
  activeAlert?: boolean
}

export interface IPersonResponse {
  id: number
  type: number
  name: string
  preferredName?: string
  email: string
  franchiseEmail?: string
  physicalPerson?: PhysicalPerson
  clientHistory?: ClientHistory
  lastClientHistory?: ClientHistory
  juridicalPerson?: JuridicalPerson
  contacts: Array<Contact>
  bank: Array<IBankData>
  addresses?: Array<IAddresses>
  medicalConditions?: Array<IMedicalConditionResponse>
  owners?: Owners
  sales?: Array<Sale>
  budgets?: Budget
  observations?: Array<IPersonObservation>
  reduceTime: boolean
  howMetId?: number
  howMetObservation?: string
  howMetName?: string
  createdAt: string
  updatedAt: string
  alerts?: Array<IPersonAlert>
  activeAlert?: boolean
}
export type ClientHistory = {
  id: number
  observation: string
  status_id: number
  status: Status
  createdAt: string
}
type Status = {
  id: number
  name: string
  color: string
  createdAt: string
  updatedAt: string
}

type Budget = {
  id: ID
  price: string
  encryptId: string
  createdAt: string
  updatedAt: string
}
type JuridicalPerson = {
  cnpj: string
  cnpjWithoutMask: string
  fantasyName: string
  municipalRegistration: number
  stateRegistration: Nationality
  taxSubstitute: string
  name: string
  physicalPerson?: PhysicalPerson
  type: number
  createdAt: string
  updatedAt: string
}

export type PhysicalPerson = {
  preferredName?: string
  document: string
  rg?: string
  birthDate: string
  job?: string
  age: number
  nationality: Nationality
  gender: string
  reduceTime: boolean
  hideAvatar: boolean
  contact?: Contact[]
}
type Owners = {
  id: number
  type: number
  name: string
  emil: string
  createdAt: string
  updatedAt: string
}
export type Nationality = {
  id: ID
  name: string
  createdAt: string
  updatedAt: string
}

type ContactType = {
  id?: ID
  name?: string
  createdAt?: string
  updatedAt?: string
}

export type Contact = {
  id: number
  typeId: number
  typeName: string
  phone: string
  phoneCode: number
  countryId?: number
  createdAt: string
  updatedAt: string
  contactTypes?: ContactType
}

export type IContactCountry = {
  formalName?: string
  id: number
  iso?: string
  iso3?: string
  name: string
  phoneCode: number
}

export type ContactRequest = {
  id?: number
  type: number
  phone: string
  phoneCode: number
  countryId: number
}

export type TSearchClientValidate = {
  name: string
  document: string
}

export type TFieldPerson = {
  name: string
  document: string
  dropdownOpen: boolean
  isFetching: boolean
  search: any[]
}

type IPersonObservation = {
  id: number
  observation: string
  user: string
  createdAt: string
  updatedAt: string
}

export type IPersonAlert = {
  id: number
  observation: string
  user: string
  createdAt: string
  updatedAt: string
}

type TPersonChangeStatus = {
  status: number | null
  observation: string
}
export type TPersonChangeStatusRequest = TPersonChangeStatus

export type TPersonChangeStatusForm = TPersonChangeStatus

export const createPersonChangeStatusInitValues: TPersonChangeStatusForm = {
  status: null,
  observation: '',
}

export type TPersonTab =
  | 'PERSONALDATA'
  | 'VOUCHER'
  | 'BILLING'
  | 'CONTRACTS'
  | 'BUDGETS'
  | 'MEDICALRECORDS'
  | 'EVALUATION'
  | 'SCHEDULEHISTORY'
  | 'MEDICALCONDITION'
  | 'STATUSHISTORY'
  | 'OBSERVATIONSHISTORY'
